<template lang="pug">
div(
    v-if="!paragraph"
    class="tl-loading-skeleton"
)
div(
    v-else
)
    div(class="tl-loading-skeleton paragraph")
    div(class="tl-loading-skeleton paragraph")
    div(class="tl-loading-skeleton paragraph")
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    paragraph: Boolean,
})

const injects = getInjects(props, inject)

const paragraph = computed(() => props.paragraph ?? injects.paragraph?.value)
</script>

<style lang="sass" scoped>
.tl-loading-skeleton
    background: linear-gradient(90deg, var(--color-tint-light) 15%, hsla(0, 0%, 45%, .5) 45%, var(--color-tint-light) 75%)
    background-size: 400% 100%
    animation: skeleton-loading 1s infinite
    border-radius: var(--border-radius)
    opacity: 0.2
    height: 50px

    &.paragraph
        height: 16px
        margin-bottom: 5px
        &:last-child
            width: 60%

@keyframes skeleton-loading
    0%
        background-position: 100% 50%
    100%
        background-position: 0 50%
</style>
